import { useFormInputs } from '@lbcamden/lib-react';
import { FunctionComponent, useEffect, useMemo, useState } from 'react';

import { calculateRiskLevel } from '~/common/config/pcfra/risk';
import { riskToResidentPremisesSchema } from '~/common/schemas/pcfra';

import { Container } from '../../PcfraCreateEditPage.styled';
import { SectionFormProps } from '../../types';
import { SectionHeading } from '../common.styled';
import { riskToResidentPremisesFormConfig, RiskToResidentPremisesFormValues } from './config';

export const RiskToResidentPremises: FunctionComponent<SectionFormProps> = ({
  draftValues,
  showErrors,
  onChange,
}) => {
  const [config, setConfig] = useState(
    useMemo(() => riskToResidentPremisesFormConfig(draftValues?.riskToResidentPremises || {}), []),
  );

  const {
    formState: { data, updateField },
    formInputs,
  } = useFormInputs<RiskToResidentPremisesFormValues>({
    config,
    schema: riskToResidentPremisesSchema,
    value: draftValues?.riskToResidentPremises as RiskToResidentPremisesFormValues,
    showErrors,
  });

  const { fireLikelihood, harmPotential } = data;

  const updateCurrentRiskLevel = () => {
    if (fireLikelihood === undefined || harmPotential === undefined) {
      return;
    }
    updateField('currentRiskLevel', calculateRiskLevel(fireLikelihood, harmPotential));
  };

  useEffect(() => {
    setConfig(riskToResidentPremisesFormConfig(data));
  }, [data]);

  useEffect(updateCurrentRiskLevel, [fireLikelihood, harmPotential]);

  useEffect(() => {
    onChange({ riskToResidentPremises: data });
  }, [data]);

  return (
    <Container>
      <SectionHeading>Risk to resident</SectionHeading>
      {formInputs}
    </Container>
  );
};
